import styles from "@styles/View.module.css";
import type { FC } from "react";
import Skeleton from "./Skeleton";

const TileSkeleton: FC = () => (
  <div className="w-full" data-type="button">
    <div className="overflow-hidden rounded-md">
      <Skeleton className="aspect-[16/7] max-h-[200px] min-h-[125px] w-full rounded-none rounded-t-md" />
      <Skeleton className="h-14 w-full rounded-none rounded-b-md" />
    </div>
    <Skeleton className="mt-2 h-11 w-full rounded" />
  </div>
);

/** Layout-matched placeholder for the lazy-loaded Home view. */
const HomeSkeleton: FC = () => {
  return (
    <>
      <div className={`${styles.homeView} w-full`} aria-busy="true" aria-live="polite">
        <span className="sr-only">Loading your rewards</span>

        <div className={`${styles.homeLogo} mt-6`}>
          <Skeleton className="aspect-[80/29] w-full max-w-70 rounded-md md:max-w-90" />
        </div>

        <div className={styles.message}>
          <Skeleton className="mx-auto mb-2 h-7 w-72 max-w-full rounded-md" />
          <Skeleton className="mx-auto h-5 w-52 max-w-full rounded-md" />
        </div>

        <section className={styles.boxTiles}>
          <TileSkeleton />
          <TileSkeleton />
        </section>

        <Skeleton className="mx-auto h-12 w-full max-w-3xl rounded-md" />
      </div>

      <footer className={`${styles.homeFooter} w-full max-w-none`}>
        <div className="box-border flex w-full flex-col items-stretch gap-4 pt-6 text-center tablet:flex-row tablet:items-center tablet:justify-between">
          <div className="flex flex-col items-center gap-2 tablet:flex-row">
            <Skeleton className="size-12 shrink-0 rounded-full" />
            <div className="flex flex-col items-center gap-2 tablet:items-start">
              <Skeleton className="h-5 w-40 rounded-md" />
              <Skeleton className="h-4 w-48 rounded-md" />
            </div>
          </div>
          <Skeleton className="h-12 w-full shrink-0 rounded-md tablet:w-36" />
        </div>
      </footer>
    </>
  );
};

export default HomeSkeleton;
